import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const phishStats = defineConnector({
  identifier: "phishStats",
  name: "PhishStats",
  tagLine: "Phishing feed and telemetry",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://phishstats\\.info/.*",
  auth: customAuth("noop"),
  steps: [
    {
      title: "Review the PhishStats API docs",
      items: [
        {
          kind: "markdown",
          content:
            "Review the official docs at [https://phishstats.info/api-docs](https://phishstats.info/api-docs) before testing this app.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://phishstats.info/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://phishstats.info:2096/api/phishing")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
